var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_, numberOfActiveDots, partnerShows, undefined) {
var imageWidth = 800
var imageHeight = 450
buf.push("<div class=\"hero-shows-carousel\">");
if ( partnerShows.length > 1)
{
buf.push("<a disabled class=\"mgr-arrow-left icon-chevron-left js-mgr-prev\"></a>");
}
buf.push("<div class=\"hero-shows-carousel-captions\">");
// iterate partnerShows
;(function(){
  var $$obj = partnerShows;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var show = $$obj[i];

buf.push("<div" + (jade.cls(['hero-show-caption',(i == 0 ? 'is-active' : undefined)], [null,true])) + "><div class=\"hero-show-subtitle\">" + (jade.escape((jade_interp = show.statusLabel()) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = show.formatShowOrFairCity()) == null ? '' : jade_interp)) + " Show</div><div class=\"hero-show-title\"><a" + (jade.attr("href", show.href(), true, true)) + ">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</a></div><div class=\"hero-show-location-and-time\">" + (jade.escape(null == (jade_interp = _.compact([show.formatShowOrFairCity(), show.runningDates()]).join(', ')) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var show = $$obj[i];

buf.push("<div" + (jade.cls(['hero-show-caption',(i == 0 ? 'is-active' : undefined)], [null,true])) + "><div class=\"hero-show-subtitle\">" + (jade.escape((jade_interp = show.statusLabel()) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = show.formatShowOrFairCity()) == null ? '' : jade_interp)) + " Show</div><div class=\"hero-show-title\"><a" + (jade.attr("href", show.href(), true, true)) + ">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</a></div><div class=\"hero-show-location-and-time\">" + (jade.escape(null == (jade_interp = _.compact([show.formatShowOrFairCity(), show.runningDates()]).join(', ')) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

if ( partnerShows.length > 1)
{
buf.push("<div class=\"mgr-dots\">");
// iterate partnerShows
;(function(){
  var $$obj = partnerShows;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var _ = $$obj[i];

var classes = i == 0 ? ['is-active'] : []
classes = i >= numberOfActiveDots ? classes.concat(['is-deemphasized']) : classes
classes = i > numberOfActiveDots ? classes.concat(['is-hidden']) : classes
buf.push("<div" + (jade.cls(['mgr-dot','js-mgr-select',classes], [null,null,true])) + "></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var _ = $$obj[i];

var classes = i == 0 ? ['is-active'] : []
classes = i >= numberOfActiveDots ? classes.concat(['is-deemphasized']) : classes
classes = i > numberOfActiveDots ? classes.concat(['is-hidden']) : classes
buf.push("<div" + (jade.cls(['mgr-dot','js-mgr-select',classes], [null,null,true])) + "></div>");
    }

  }
}).call(this);

buf.push("</div>");
}
buf.push("</div><div class=\"hero-shows-carousel-images\"><div class=\"mgr-cells js-mgr-cells\">");
// iterate partnerShows
;(function(){
  var $$obj = partnerShows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", show.href(), true, true)) + "><img" + (jade.attr("src", show.cropUrlFor({ width: imageWidth, height: imageHeight }), true, true)) + "></a></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

buf.push("<div class=\"mgr-cell js-mgr-cell\"><a" + (jade.attr("href", show.href(), true, true)) + "><img" + (jade.attr("src", show.cropUrlFor({ width: imageWidth, height: imageHeight }), true, true)) + "></a></div>");
    }

  }
}).call(this);

buf.push("</div></div>");
if ( partnerShows.length > 1)
{
buf.push("<a class=\"mgr-arrow-right icon-chevron-right js-mgr-next\"></a>");
}
buf.push("</div>");}.call(this,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"numberOfActiveDots" in locals_for_with?locals_for_with.numberOfActiveDots:typeof numberOfActiveDots!=="undefined"?numberOfActiveDots:undefined,"partnerShows" in locals_for_with?locals_for_with.partnerShows:typeof partnerShows!=="undefined"?partnerShows:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;